import axios from "axios";

export async function callApiComment(url, data){
    return await axios.post(url, data);
}


// WEBPACK FOOTER //
// ./src/helpers/ApiComment.js